<!-- Dialog title -->
<h1 mat-dialog-title>
  <div class="flex flex-row items-center">
    <div
      class="flex flex-row items-center mx-2 justify-center bg-accent-900 rounded-full h-10 w-10"
    >
      <mat-icon class="icon-size-5" color="primary" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
    </div>
    <span class="text-primary text-lg font-semibold">{{ 'Enable Notifications' | transloco }}</span>
  </div>
</h1>
<mat-divider class="my-4"></mat-divider>

<!-- Dialog content -->
<div mat-dialog-content class="dialog-content">
  <p class="instructions-title">{{ browserInstructionsTitle }}</p>
  <ul class="instructions-list ms-6">
    <li *ngFor="let step of browserInstructionsSteps" class="instructions-step">
      {{ step }}
    </li>
  </ul>
</div>

<div *ngIf="image" class="flex flex-row justify-center w-full items-center">
  <img class="flex flex-row p-4 rounded-md bg-accent-900 w-full" [src]="image" />
</div>

<div mat-dialog-actions class="flex flex-row w-full justify-end mt-4">
  <button mat-flat-button class="mat-dense" mat-dialog-close color="primary">
    {{ 'Close' | transloco }}
  </button>
</div>
